import React, { useState } from "react";
import check from "../../assets/check_small.svg";
import { useEffect } from "react";
import { useUser } from "providers/UserProvider";
import { useInterceptor } from "providers/InterceptorProvider";

const VSFilter = ({ onApply, table, filterData }) => {
  const [selectedItems, setSelectedItems] = useState(filterData);
  const [valueStreams, setValueStreams] = useState([]);
  const { user } = useUser();
  const { api } = useInterceptor();

  useEffect(() => {
    async function fetchNodes() {
      if (table === "Value-Stream") {
        const response = await api.get(
          `/dashboard/value-stream-nodes/${user.organizationId}`
        );
        setValueStreams(response?.data?.data);
      } else if (table === "Activity") {
        const response = await api.get(
          `/dashboard/activity-nodes/${user.organizationId}`
        );
        setValueStreams(response?.data?.data);
      } else {
        const response = await api.get(
          `/dashboard/function-nodes/${user.organizationId}`
        );
        setValueStreams(response?.data?.data);
      }
    }
    fetchNodes();
  }, [user]);

  useEffect(() => {
    console.log({ valueStreams });
  }, [valueStreams]);

  const handleToggle = (item) => {
    setSelectedItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };
  const handleReset = () => {
    setSelectedItems([]);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-80 w-screen h-screen flex justify-center items-center font-inter">
      <div className="bg-white w-[500px] rounded-[10px]">
        <div className="flex justify-between border-b-[1.5px] border-[#D9D9D9] px-7 py-3">
          <div className="font-semibold text-[16px]">Filter</div>
          <div className="flex gap-1 items-center">
            <img src={check} alt="" className="w-4" />
            <span className="text-sm text-[#55C880]">
              Selected {selectedItems.length}
            </span>
          </div>
        </div>
        <div className="mb-20 px-7">
          {valueStreams.map((item) => (
            <label
              key={item._id}
              className="flex items-center my-2 pt-3 pb-2 cursor-pointer border-b border-[#D9D9D9]"
            >
              <div className="relative flex items-center">
                <input
                  type="checkbox"
                  className="hidden"
                  checked={selectedItems.includes(item._id)}
                  onChange={() => {
                    handleToggle(item._id);
                  }}
                />
                <div
                  className={`w-4 h-4 border rounded-[3px] flex items-center justify-center ${
                    selectedItems.includes(item._id)
                      ? "border-[#55C880] bg-[#55C880]"
                      : "border-gray-300"
                  }`}
                >
                  {selectedItems.includes(item._id) && (
                    <svg
                      width="11"
                      height="10"
                      viewBox="0 0 13 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.49386 9.04421L0.849609 5.39996L1.89386 4.35571L4.49386 6.95571L11.0939 0.355713L12.1381 1.39996L4.49386 9.04421Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <span className="ml-3 text-sm text-gray-700">{item.name}</span>
            </label>
          ))}
        </div>
        <div className="flex justify-between px-7 py-3 border-t border-[#D9D9D9]">
          <button
            className="border border-[#D9D9D9] rounded-[10px] px-5 py-1.5 text-sm font-medium"
            onClick={handleReset}
          >
            Reset
          </button>
          <button
            className="bg-[#55C880] rounded-[10px] text-white text-sm px-5 py-1.5"
            onClick={() => onApply(selectedItems, table)}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default VSFilter;
